/**
 * Wave 6 compatibility shim.
 *
 * The canonical store is now `useProjectImagesStore`. This file re-exports
 * it under the legacy name so existing imports keep working. It exposes both
 * the new (`images`, `upsertImage`, ...) and legacy (`keyframes`,
 * `upsertKeyframe`, ...) method names — see useProjectImagesStore.js for the
 * full method list.
 *
 * New code should import { useProjectImagesStore } directly.
 */

export { useProjectImagesStore as useProjectKeyframesStore } from './useProjectImagesStore';
